const questions = [
    {
        "question": "question1",
        "answer": "answer1"
    },
    {
        "question": "question2",
        "answer": "answer2"
    },
    {
        "question": "question3",
        "answer": "answer3"
    },
    {
        "question": "question4",
        "answer": "answer4"
    },
    {
        "question": "question5",
        "answer": "answer5"
    },
    {
        "question": "question6",
        "answer": "answer6"
    }
]

export default questions;

// "domanda1" : "Dall'Aeroporto Internazionale di Napoli Capodichino",
// "risposta1" : "Per raggiungere la struttura dall'aereoporto bisogna prima giungere al porto di Napoli (Calata di Massa o Molo Beverello) utilizzando un taxi o l’ALIBUS con fermata proprio fronte aeroporto. Successivamente bisognerà prendere un traghetto.",



// Traghetto da NAPOLI 
// Al porto bisogna prendere un traghetto (Porto Calata di Massa) o un aliscafo (Porto Molo Beverello) direzione Procida. Le compagnie di navigazioni disponibili per questo porto sono: Caremar SNAV Medmar (solo alcune corse) Traghetto - DA POZZUOLI 
// Giunti al porto di Pozzuoli sarà possibile raggiungere l’Isola utilizzando un traghetto o aliscafo. Le compagnie disponibili in questo porto sono: Caremar SNAV Gestour Medmar (solo alcune corse) Scotto Lines (solo alcuni periodo dell’anno) Ippocampo (solo alcuni periodo dell’anno) 
// Autobus su PROCIDA 
// Giunti al porto di Procida troverete, adiacente alla biglietteria/stazione marittima, lo stazionamento degli autobus EAV. E’ possibile raggiungere la nostra struttura utilizzando la Linea L1 o la Linea L2 richiedendo la fermata “Campo Sportivo”, “Leone di Mare”, “Via Cavone”